export default __webpack_public_path__ + "static/media/websiteLight.a0500030.svg";